import HotelCardGallery from './HotelCardGallery';

export default HotelCardGallery;
